import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../compliant-list/compliant-list-table/CompliantListTable.css";
import plus from "../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../Components/Admin/assets/icons/search.png";
import top from "../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import ComHeader from "../com-header/ComHeader";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModalDelete";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";

import Pagination from "react-bootstrap/Pagination";
import Service_History_modal from "../../common/modal/service_history_modal/Service_History_modal";
import Extend_Service_Modal from "../../common/modal/extend_service_modal/Extend_Service_Modal";
import { Button, Row } from "react-bootstrap";
import { getDownloadDataExcel } from "../../../utils/api";
library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
  } = useContext(Context);

  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [history, setHistory] = useState([]);
  const [showExtendModal, setShowExtendModal] = useState(false);

  const [extended, setExtended] = useState("");

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const [totalPages, settotalPages] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}>
        {page}
      </Pagination.Item>,
    );
  }

  const getDataAll = async () => {
    const response = await getData(
      `/masters/customer?page=${onPageChange}&per_page=${perPage}&term=${search}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/masters/customer/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/masters/customer/${recordToDeleteId}`,
      );

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const formatMonth = (value) => {
    if (!value) return "";

    let date;

    if (value.length === 7) {
      // Case: YYYY-MM → default day = 01
      const [year, month] = value.split("-");
      date = new Date(year, month - 1, 1);
    } else {
      // Case: YYYY-MM-DD
      date = new Date(value);
    }

    return date.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const HandleDownload = async () => {
    try {
      await getDownloadDataExcel(
        "/masters/customer/download",
        {},
        `customer list`,
      );
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      {/* <div className="main-advancedashboard"> */}
      {/* <ComHeader title={"Customer"} link={"/masters/customer"} /> */}
      <section className="AdvanceDashboard">
        <Row>
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-5">
              <div className="">
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3">
                      <Link type="button" className="btn btn-add pe-3">
                        <div onClick={() => handleShow()}>
                          <img src={plus} className="plus me-2 ms-0" alt="" />
                          Add Customer
                        </div>
                      </Link>
                    </div>
                    <div className="add me-3">
                      <button
                        className="view_btn  btn btn-danger"
                        onClick={HandleDownload}>
                        Download data in Excel &nbsp;
                        <FontAwesomeIcon
                          icon="fa-solid fa-file-lines "
                          // className="pdf-icon"
                          // variant="success"
                        />
                      </button>
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className="  col-lg-4 col-md-4 col-12">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}>
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">Entries</p>
                        </div>
                      </div>
                    </div>
                    <div className="  col-lg-8  col-md-8 col-12">
                      <div className="d-flex justify-content-end">
                        {/* <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries,
                          )} of ${data?.data?.totalEntries} Entries`}</p>
                        </div> */}
                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="Search me-2">
                          <button
                            type="button"
                            onClick={getDataAll}
                            className="btn btn-search">
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset">
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-3"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {visible.col1 && <th className="sr">Sr. No.</th>}
                          {visible.col2 && <th className="tax-name">Name </th>}
                          {visible.col3 && (
                            <th className="tax-name">Contact Number </th>
                          )}
                          {visible.col4 && <th className="tax-name">Email </th>}
                          {visible.col5 && (
                            <th className="tax-name">Subscription Date </th>
                          )}
                          {visible.col6 && (
                            <th className="tax-name">View Service History </th>
                          )}{" "}
                          {visible.col7 && (
                            <th className="tax-name">Extend Service </th>
                          )}
                          {visible.col8 && <th className="tax-name">Status</th>}
                          {visible.col9 && <th className="active">Action</th>}
                        </tr>
                      </thead>
                      <tbody className="table-body-holder">
                        {data?.data?.data?.map((d, index) => {
                          return (
                            <tr className="heads-main" key={index}>
                              {visible.col1 && <td>{++index}.</td>}
                              {visible.col2 && <td>{d?.name}</td>}{" "}
                              {visible.col3 && <td>{d?.contact_no}</td>}{" "}
                              {visible.col4 && <td>{d?.email}</td>}
                              {visible.col5 && (
                                <td>{`${formatMonth(
                                  d.start_month,
                                )} - ${formatMonth(d.end_month)}`}</td>
                              )}
                              {visible.col6 && (
                                <td>
                                  <Button
                                    className="add-neww-btn"
                                    onClick={() => {
                                      setShowHistoryModal(true);
                                      setHistory(d?.customer_service_histories);
                                    }}>
                                    View History
                                  </Button>
                                </td>
                              )}
                              {visible.col7 && (
                                <td>
                                  {
                                    <Button
                                      className="add-neww-btn"
                                      onClick={() => {
                                        setShowExtendModal(true);
                                        setExtended(d);
                                      }}>
                                      Extend Service
                                    </Button>
                                  }
                                </td>
                              )}
                              {visible.col8 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d.status}
                                      onChange={() => {
                                        ChangeStatus(d.id);
                                      }}
                                      id={`flexSwitchCheckDefault${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`flexSwitchCheckDefault${d?.id}`}>
                                      {d.status ? "Active" : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}
                              {visible.col9 && (
                                <td>
                                  <div className="d-flex">
                                    <EditButton
                                      handleShow1={handleShow1}
                                      id={d?.id}
                                    />

                                    <DeletButton
                                      showDeleteRecord={showDeleteRecord}
                                      id={d?.id}
                                      name={d?.name}
                                    />
                                  </div>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>{" "}
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Row>
      </section>
      {/* </div> */}

      <Service_History_modal
        show={showHistoryModal}
        history={history}
        onHide={() => {
          setShowHistoryModal(false);
        }}
      />

      <Extend_Service_Modal
        show={showExtendModal}
        extended={extended}
        getDataAll={getDataAll}
        onHide={() => {
          setShowExtendModal(false);
        }}
      />

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
